<template>
  <base-dialog @cancel="cancelDialog">
    <div slot="header">{{ params.type === 'refund' ? $t('scope.refund') : $t('scope.apply_refund') }}</div>
    <div slot="body">
      <dialog-selected-tips :name="params.data[0].type === 'consulting' ? $t('scope.technical_consulting') : $t('scope.remote_assistance')" :count="params.data.length" :action="params.type === 'refund' ? $t('scope.refund') : $t('scope.apply_refund')" />
      <dialog-table :data="params.data" :columns="columns" />
      <a-form-model v-if="params.type !== 'refund'" :model="form" :rules="rules" ref="form" v-bind="formItemLayout">
        <a-form-model-item :label="$t('scope.refund_reason')" prop="reason">
          <a-input v-model="form.reason" />
        </a-form-model-item>
      </a-form-model>
    </div>
    <div slot="footer">
      <a-button type="primary" @click="handleConfirm" :loading="loading">{{ $t('dialog.ok') }}</a-button>
      <a-button @click="cancelDialog">{{ $t('dialog.cancel') }}</a-button>
    </div>
  </base-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import DialogMixin from '@/mixins/dialog'
import WindowsMixin from '@/mixins/windows'
import { validateModelForm } from '@/utils/validate'

export default {
  name: 'SaasTechSupportRefundDialog',
  mixins: [DialogMixin, WindowsMixin],
  data () {
    return {
      loading: false,
      formItemLayout: {
        wrapperCol: {
          span: 21,
        },
        labelCol: {
          span: 3,
        },
      },
      form: {
        reason: '',
      },
      rules: {
        reason: [
          { required: true, message: this.$t('common.tips.input', [this.$t('scope.refund_reason')]) },
        ],
      },
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    columns () {
      const showFields = ['name', 'status', 'created_at']
      return this.params.columns.filter((item) => { return showFields.includes(item.field) })
    },
  },
  methods: {
    async handleConfirm () {
      this.loading = true
      try {
        if (this.params.type === 'refund') {
          await this.params.onManager('performAction', {
            id: this.params.data[0].id,
            managerArgs: {
              action: 'refund',
            },
          })
        } else {
          await validateModelForm(this.$refs.form)
          await this.params.onManager('performAction', {
            id: this.params.data[0].id,
            managerArgs: {
              action: 'request-refund',
              data: {
                reason: this.form.reason,
              },
            },
          })
        }
        this.loading = false
        this.cancelDialog()
      } catch (error) {
        this.loading = false
        throw error
      }
    },
  },
}
</script>
